import { LIVE_MANAGERIAL_KPI_IDS, MANAGERIAL_KPI_DEFINITIONS } from './managerial-kpis'

export type ManagerialKpiCriterion = {
  title: string
  description: string
  illustrativeNote: string | null
}

const LIVE_KPI_ID_SET = new Set<string>(LIVE_MANAGERIAL_KPI_IDS)

const ILLUSTRATIVE_NOTE =
  'Aguardando definição de mensuração. Nenhum valor estimado é exibido.'

const KPI_CRITERION_DESCRIPTIONS: Record<string, string> = {
  'net-revenue':
    'GMV: valor total transacionado nas vendas pagas reconhecidas do período, antes dos repasses e taxas. Não é a receita própria da plataforma. Instituição, campanha e status restringem o recorte.',
  'operating-profit':
    'Parcela da plataforma nos splits LEGAL PRIME/Fábio registrados para vendas pagas reconhecidas. Respeita período, instituição, campanha e status. Não desconta despesas operacionais e não representa lucro líquido ou EBITDA.',
  'operating-margin':
    'Receita da plataforma registrada nos splits dividida pelo volume transacionado (GMV) do mesmo recorte. Mede a participação da plataforma nas vendas; não é Margem Bruta nem margem líquida.',
  'active-clients':
    'Compradores distintos com pelo menos um pagamento pago no período. Instituição e campanha restringem o recorte. Status pendente, cancelado ou expirado zera o indicador.',
  'active-campaigns':
    'Campanhas com status administrativo ativo e pelo menos uma venda paga. Sem venda, a campanha não entra. Instituição e campanha restringem o recorte. Período e status do pedido não entram nesta conta.',
  'leads-12m':
    'Compradores identificados distintos (donor_id, sem cadastros temporários de convidados) que iniciaram checkout no período e recorte selecionados. Inclui checkouts de IA pela data original da compra, sem duplicar seu pagamento. Exclui importações e não depende do status do pedido. Não mede visitantes anônimos ou compras independentes de avatar e mascote.',
  'average-ticket':
    'Soma dos pagamentos pagos dividida pela quantidade desses pedidos no período. Instituição e campanha restringem o recorte. Status pendente, cancelado ou expirado zera o indicador.',
  'active-institutions':
    'Instituições com ao menos uma campanha que já teve venda paga. Sem venda, a instituição não entra. Período e status do pedido não entram nesta conta. Instituição e campanha restringem o recorte para 1 ou 0.',
  'paid-orders':
    'Pagamentos com status pago e data de pagamento dentro do período. Instituição e campanha restringem o recorte. Status pendente, cancelado ou expirado zera o indicador.',
  'sold-numbers':
    'Soma das quantidades dos pedidos pagos de campanhas com números no período selecionado. Exclui campanhas somente de doação, pagamentos revertidos e prêmios independentes da roleta. Inclui números comprados com entrega ainda pendente. Instituição, campanha e status restringem o recorte.',
  'conversion-rate':
    'Percentual dos leads de checkout do recorte com pelo menos um desses checkouts pago e não revertido dentro da mesma janela, após sua entrada. Cada comprador conta uma vez. Compras iniciadas antes do período não convertem a coorte atual. Status pendente, cancelado ou expirado zera o indicador.',
  'active-affiliates':
    'Afiliados distintos com pelo menos um pagamento pago atribuído no período. Instituição e campanha restringem o recorte. Status pendente, cancelado ou expirado zera o indicador.',
}

export function getManagerialKpiCriterion(id: string): ManagerialKpiCriterion | null {
  const description = KPI_CRITERION_DESCRIPTIONS[id]
  if (!description) {
    return null
  }

  const placeholder = MANAGERIAL_KPI_DEFINITIONS.find((item) => item.id === id)

  return {
    title: placeholder?.label ?? id,
    description,
    illustrativeNote: LIVE_KPI_ID_SET.has(id) ? null : ILLUSTRATIVE_NOTE,
  }
}

export function listManagerialKpiIdsWithCriteria(): string[] {
  return MANAGERIAL_KPI_DEFINITIONS.map((item) => item.id)
}
